import { useEffect } from "react";

const FacebookSDKLoader = () => {
  useEffect(() => {
    // Load the SDK only once
    if (document.getElementById("facebook-jssdk")) return;

    // Create script element
    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;

    // Append the script to body
    document.body.appendChild(script);

    // Wait for script to load, then init FB
    script.onload = () => {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: process.env.REACT_APP_META_APP_POST_SHARING, // Replace with your App ID
          cookie: true,
          xfbml: true,
          version: "v23.0", // Replace with your API version
        });

        window.FB.AppEvents.logPageView();
      };
    };
  }, []);

  return null; // No UI, just loads the SDK
};

export default FacebookSDKLoader;
